import { render, staticRenderFns } from "./DegreeTypePickerInput.vue?vue&type=template&id=0496a4d0&scoped=true&"
import script from "./DegreeTypePickerInput.vue?vue&type=script&lang=js&"
export * from "./DegreeTypePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496a4d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCard,VChip,VFlex})
